/* eslint-disable no-nested-ternary */
import React, { Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import H3CustomInput from '@Uilib/h3CustomInput';
import CFV2Actions from '@Actions/configurations/cfV2Actions';
import './style.scss';

const evaluateExpression = (expression, fieldType, cfMap) => expression.replace(/{{cf_(\d+)}}/g, (match, p1) => {
  const field = cfMap[p1];

  // if (fieldType === 'TEXT') {
  //   return field ? ` '${field.fieldValue || ''}' ` : '';
  // }
  return field ? ` ${Number(field.fieldValue || '0')} ` : 0;
});

export const updateCfValueParent = (updatedValue, currentCf, fieldType, customLineInputChange, cfMap, cfId) => {
  const updateCfValue = (value, cf) => {
    try {
      // Update the value in the cfMap
      cfMap[cf.cfId].fieldValue = fieldType === 'ATTACHMENT'
        ? value?.map((attachment) => ({
          url: attachment?.response?.response?.location || attachment?.url,
          type: attachment?.type,
          name: attachment?.name,
          uid: attachment?.uid,
        })) : (fieldType === 'NUMBERS' ? Number(value) : value);
      // Process each dependent field
      cf?.dependentFields?.forEach((dependentFieldId) => {
        const dependentField = cfMap[dependentFieldId];
        if (dependentField?.defaultExpression) {
          const expression = dependentField.defaultExpression;
          const evaluatedValue = eval(evaluateExpression(expression, fieldType, cfMap));
          updateCfValue(evaluatedValue, dependentField);
        }
      });

      if (!cf?.dependentFields?.length) {
        customLineInputChange(Object?.values(cfMap), cfId);
      }
    } catch (e) {
      console.log('automatic calculation failure', e);
    }
  };
  updateCfValue(updatedValue, currentCf);
};

const CustomFieldLine = ({
  customFields, formSubmitted, customLineInputChange, cfWrapperClassName, disableCase, isHorizontalUi, inputClassName,
  containerClassName, wrapperClassName, cfId, isUpdate, match, isCarryForward, disabled, fullWidth, batchClass,
}) => {
  const cfMap = {};
  const recordCf = JSON.parse(JSON.stringify(customFields));
  for (let i = 0; i < recordCf?.length; i++) {
    const cf = recordCf[i];
    cfMap[cf?.cfId] = cf;
  }
  const isDocumentInUpdateState = match.url.includes('/update') || (isUpdate === true);
  const isDocumentIsCarryForwarding = isCarryForward;
  const shouldDisableField = (customField) => (
    disableCase
    || (isDocumentInUpdateState && customField.isEditable === false)
    || (isDocumentIsCarryForwarding && customField.isCarryForward === false)
  );
  return (
    <div className="cf-line__wrapper">
      <div className={isHorizontalUi ? `cf-line_horizontal ${cfWrapperClassName || ''}` : cfWrapperClassName}>
        {customFields?.filter((item) => (item.cfId === cfId && item.isActive && item?.fieldType?.toUpperCase() !== 'ATTACHMENT' && item?.fieldType?.toUpperCase() !== 'CHECKBOX' && item?.fieldType?.toUpperCase() !== 'TEXTAREA'))?.map((customField, index) => (
          <Fragment key={customField?.cfId}>
            <div key={customField?.cfId} className={wrapperClassName}>
              <H3CustomInput
                containerClassName={`orgInputContainer ${containerClassName || ''} 
${isHorizontalUi ? 'custom-field__wrapper'
                  : (index % 2 === 0 ? 'cf-line_input-right' : 'cf-line_input-left')} 
${fullWidth ? 'full-width' : ''}`}
                customClassName="pr_input_custom_field"
                inputClassName={batchClass ? 'custom__field-batch' : `${isHorizontalUi ? 'custom-field-input ' : ''}${inputClassName || ''} ${customField?.fieldType?.toUpperCase() === 'DROPDOWN' ? '' : 'orgFormInput'}`}
                inputErrorClassName="cf-line__input-error"
                type={customField?.fieldType?.toUpperCase()}
                required={customField?.isRequired}
                options={customField?.defaultData?.length ? customField?.defaultData : []}
                placeholder={customField?.placeholder}
                onChange={(value) => {
                  updateCfValueParent(value, customField, customField?.fieldType?.toUpperCase(), customLineInputChange, cfMap);
                }}
                value={customField?.fieldValue}
                showError={formSubmitted && customField?.isRequired && !customField?.fieldValue}
                disabled={shouldDisableField(customField) || disabled}
                isHorizontalUi={isHorizontalUi}
                islineFields
                showErrorCheckBox={formSubmitted && customField?.isRequired && !customField?.fieldValue}
                ISTEndOfDay
              />
            </div>
          </Fragment>
        ))}

        {customFields?.filter((item) => (item.cfId === cfId && item.isActive && (item?.fieldType?.toUpperCase() === 'ATTACHMENT' || item?.fieldType?.toUpperCase() === 'CHECKBOX' || item?.fieldType?.toUpperCase() === 'TEXTAREA')))?.map((customField, index) => (
          <Fragment>
            <div key={customField?.cfId} className={wrapperClassName}>
              <H3CustomInput
                containerClassName={`orgInputContainer ${containerClassName || ''} 
${isHorizontalUi ? 'custom-field__wrapper'
                  : (index % 2 === 0 ? 'cf-line_input-right' : 'cf-line_input-left')} 
${fullWidth ? 'full-width' : ''}`}
                customClassName="pr_input_custom_field"
                inputClassName={batchClass ? 'custom__field-batch' : `${isHorizontalUi ? 'custom-field-input ' : ''}${inputClassName || ''} ${customField?.fieldType?.toUpperCase() === 'DROPDOWN' ? '' : 'orgFormInput'}`}
                inputErrorClassName="cf-line__input-error"
                type={customField?.fieldType?.toUpperCase()}
                required={customField?.isRequired}
                options={customField?.defaultData?.length ? customField?.defaultData : []}
                placeholder={customField?.placeholder}
                onChange={(value) => {
                  updateCfValueParent(value, customField, customField?.fieldType?.toUpperCase(), customLineInputChange, cfMap);
                }}
                value={customField?.fieldValue}
                showError={formSubmitted && customField?.isRequired && (customField?.fieldType?.toUpperCase() == 'ATTACHMENT' ? (!customField?.fieldValue || customField?.fieldValue?.length == 0) : !customField?.fieldValue)}
                disabled={shouldDisableField(customField) || disabled}
                isHorizontalUi={isHorizontalUi}
                islineFields
                showErrorCheckBox={formSubmitted && customField?.isRequired && !customField?.fieldValue}
                ISTEndOfDay
              />
            </div>
          </Fragment>
        ))}

      </div>
    </div>
  );
};
const mapStateToProps = () => ({

});

const mapDispatchToProps = (dispatch) => ({
  getCFV2Success: (customFields) => dispatch(CFV2Actions.getCFV2Success(customFields)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(CustomFieldLine));
